const ServiceProviderSpIdType = Symbol();

// SPIDの最大長
export const ServiceProviderSpIdMaxLength = 200;

export class ServiceProviderSpId {
    [ServiceProviderSpIdType]: any;
    readonly value: string;

    private constructor(spId: string) {
        this.value = spId;
    }

    static fromString(spId: string): ServiceProviderSpId {
        return new ServiceProviderSpId(spId);
    }

    static fromNothing(): ServiceProviderSpId {
        return new ServiceProviderSpId("");
    }

    // SPIDの長さチェック
    isValidLength(): boolean {
        return !!this.value.length && !(this.value.length > ServiceProviderSpIdMaxLength);
    }
}
